<div>
  <form [formGroup]="generalAccountInfoForm" *ngIf="formLoaded">
    <ion-item>
      <ion-select [label]="'GENERAL.ACCOUNT_TYPE' | translate" formControlName="type" [disabled]="!editing">
        <ion-select-option value="Company">{{ 'GENERAL.COMPANY' | translate }}</ion-select-option>
        <ion-select-option value="Personal">{{ 'GENERAL.PERSONAL' | translate }}</ion-select-option>
        <ion-select-option value="School">{{ 'GENERAL.SCHOOL' | translate }}</ion-select-option>
        <ion-select-option value="College / University">{{ 'GENERAL.COLLEGE_UNIVERSITY' | translate }}</ion-select-option>
        <ion-select-option value="School District">{{ 'GENERAL.SCHOOL_DISTRICT' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>
    
    <ion-item >
      <ion-input [label]="'GENERAL.NUMBER_OF_KILNS' | translate" class="ion-text-right" [readonly]="!editing" formControlName="numberControllers"></ion-input>
    </ion-item>

    <ion-item>
      <ion-input disabled="true" type="date" format="MMM dd, yyyy" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="expiration" [class.danger]="isExpired" [value]="expiration"></ion-input>
      <ion-input disabled="true" [label]="'GENERAL.EXPIRATION' | translate" *ngIf="!expiration">{{ 'GENERAL.NOT_AVAILABLE' | translate }}</ion-input>
    </ion-item>

    <ion-item>
      <ion-select [label]="'GENERAL.SUBSCRIPTION_FREQUENCY' | translate" formControlName="frequency" [disabled]="!editing">
        <ion-select-option value="kiln_annual">{{ 'GENERAL.ANNUAL' | translate }}</ion-select-option>
        <ion-select-option value="kiln_monthly">{{ 'GENERAL.MONTHLY' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item *ngIf="editing">
      <ion-input type="number" [label]="'GENERAL.RENEWALS' | translate" formControlName="renewals"></ion-input>
    </ion-item>  

    <ion-item>
      <ion-select [label]="'GENERAL.TIME_ZONE' | translate" formControlName="timezone" [class.invalid]="generalAccountInfoForm && generalAccountInfoForm.controls.timezone.valid && generalAccountInfoForm.controls.timezone.touched" [disabled]="!editing">
        <ion-select-option class="default-us-timezone" *ngFor="let zone of getTopUSTimezones()" [value]="zone">{{zone}}</ion-select-option>
        <ion-select-option *ngFor="let zone of getTimezones()" [value]="zone">{{zone}}</ion-select-option>
      </ion-select>
    </ion-item>  
    
      <!-- Language selector as a form field -->
    <ion-item class="language-item" button (click)="openLanguageSwitcher()" *ngIf="isToggleEnabled('internationalization')">
      <ion-label>{{ 'ACCOUNT_SETTINGS.LANGUAGE' | translate }}</ion-label>
      <div slot="end" class="language-display">
        <span class="language-flag">{{ currentLanguageInfo.flag }}</span>
        <span class="language-name">{{ currentLanguageInfo.name }}</span>
        <ion-icon name="chevron-forward" color="medium"></ion-icon>
      </div>
    </ion-item>

    <ion-item *ngIf="isToggleEnabled('freeToPremium') && editing && generalAccountInfoForm?.value?.frequency">
      <ion-label>{{ 'GENERAL.TOTAL_PRICE' | translate }}</ion-label>
      <ion-label slot="end">
        {{ generalAccountInfoForm.value.frequency === 'kiln_monthly' ? formatPrice(monthlyCalculation.totalPrice) : formatPrice(annualCalculation.totalPrice) }}
        <ion-icon 
          name="information-circle-outline" 
          class="info-icon"
          (click)="showPricingInfo()">
        </ion-icon>
      </ion-label>
      
      <ion-button 
          slot="end"
          expand="block" 
          (click)="calculatePrice()"
          class="calculate-button">
          {{ 'GENERAL.CALCULATE_PRICE' | translate }}
        </ion-button>
    </ion-item>    
    <ion-item *ngIf="isToggleEnabled('freeToPremium') && (!payment ? editing : true)">
      <app-account-payment #paymentsForm (startEdit)="startEditing(true)" slot="end"
        [accountInformation]="accountInformation" [canAdminister]="canAdminister" [editing]="editing">
      </app-account-payment>
    </ion-item>
    <ion-item *ngIf="isToggleEnabled('freeToPremium') && !payment && !editing">
      <ion-label slot="end">{{ 'GENERAL.NO_PAYMENT_METHOD' | translate }}</ion-label>
    </ion-item>
  </form>  

  <ion-row class="ion-justify-content-end ion-padding-end">
    <ion-button *ngIf="canAdminister" color="light" (click)="delete()">{{ 'GENERAL.DELETE' | translate }}</ion-button>
    <ion-button *ngIf="canAdminister && !editing" color="secondary" (click)="startEditing()">{{ 'GENERAL.EDIT' | translate }}</ion-button>
    <ion-button *ngIf="canAdminister && editing" color="secondary" (click)="cancelEditing()">{{ 'GENERAL.CANCEL' | translate }}</ion-button>
    <ion-button type="submit"
      [disabled]="!isValid() || !canAdminister"
      (click)="save()" *ngIf="!updatePending">{{ 'GENERAL.SUBMIT' | translate }}</ion-button>
    <div *ngIf="updatePending" class="submitpending">
      <ion-spinner name='bubbles'></ion-spinner>
      <span>{{ 'GENERAL.UPDATING' | translate }}</span>
    </div>
  </ion-row>

  <!-- Pricing Info Modal -->
  <ion-modal #pricingModal [isOpen]="showPricingModal" (didDismiss)="closePricingInfo()">
    <ng-template>
      <ion-header>
        <ion-toolbar>
          <ion-title>{{ 'GENERAL.PRICING_INFORMATION' | translate }}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="closePricingInfo()">{{ 'GENERAL.CLOSE' | translate }}</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <div class="pricing-info-container">
          <div class="info-section">            
            <h5><ion-icon name="calculator-outline" class="info-icon"></ion-icon> {{ 'GENERAL.HOW_PRICING_WORKS' | translate }}</h5>
            <p class="info-text">
              {{ 'GENERAL.PRICING_EXPLANATION' | translate }}
            </p>
          </div>
          
          <div class="info-section">
            <h5><ion-icon name="calendar-outline" class="info-icon"></ion-icon> {{ 'GENERAL.ANNUAL_SAVINGS' | translate }}</h5>
            <p class="info-text">
              {{ 'GENERAL.ANNUAL_SAVINGS_EXPLANATION' | translate }}
            </p>
          </div>

          <div *ngIf="monthlyCalculation && annualCalculation" class="pricing-comparison">
            <h3 class="comparison-title">{{ 'GENERAL.YOUR_CURRENT_PRICING' | translate }}</h3>
            <ion-card class="pricing-card">
              <ion-card-content>
                <ion-grid class="pricing-grid">
                  <ion-row class="pricing-header ion-align-items-center">
                    <ion-col size="6">
                      <div class="price-column">
                        <ion-icon name="time-outline" class="column-icon"></ion-icon>&nbsp;
                        <ion-label class="pricing-label">{{ 'GENERAL.MONTHLY' | translate }}</ion-label>
                      </div>
                    </ion-col>
                    <ion-col size="6">
                      <ion-icon name="calendar-outline" class="column-icon"></ion-icon>&nbsp;
                      <ion-label class="pricing-label">{{ 'GENERAL.ANNUAL' | translate }}</ion-label>
                    </ion-col>
                  </ion-row>
                  <ion-row class="pricing-values">
                    <ion-col size="6">
                      <ion-label class="price-value">{{ formatPrice(monthlyCalculation.pricePerKiln) }}</ion-label>
                      <ion-label class="price-per">&nbsp;{{ 'GENERAL.PER_KILN_MONTH' | translate }}</ion-label>
                    </ion-col>
                    <ion-col size="6">
                      <div class="price-display">
                        <ion-label class="price-value">{{ formatPrice(annualCalculation.pricePerKiln) }}</ion-label>
                        <ion-label class="price-per">&nbsp;{{ 'GENERAL.PER_KILN_YEAR' | translate }}</ion-label>
                        <div *ngIf="generalAccountInfoForm && generalAccountInfoForm.value && generalAccountInfoForm.value.frequency === 'kiln_monthly'" class="savings-highlight">
                          <ion-icon name="trending-down-outline" class="savings-icon"></ion-icon>
                          <span class="savings-text">{{ getSavingsPercentage() | number:'1.0-1' }}% {{ 'GENERAL.SAVINGS' | translate }}</span>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card-content>
            </ion-card>
          </div>
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
</div>
